
export default [
  {
    path: '/admin/expense-postings',
    name: 'expense-posting',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/expense-posting/index.vue')
  },
  {
    path: '/admin/expense-postings/create',
    name: 'expense-posting-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/expense-posting/create.vue')
  },
  {
    path: '/admin/expense-postings/:id/edit',
    name: 'expense-posting-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/expense-posting/edit.vue')
  }
]
